/**
 * Invalid Dateか？
 * @param date
 * @returns
 */
export function isInvalidDate(date: Date): boolean {
  return Number.isNaN(date.getTime());
}

/**
 * 指定月の日数を取得
 * @param  year  年
 * @param  month 月
 * @return 指定月の日数
 */
export function getLastDay(year: number, month: number): number {
  return new Date(year, month, 0).getDate();
}

/**
 * 指定日の月の日数を取得。
 * @param date 指定日
 * @returns 指定日の月の日数
 */
export function getLastDayFromDate(date: Date): number {
  const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return lastDate.getDate();
}

/**
 * 分の加算。
 * @param date 加算される時間。
 * @param add 加算分数。
 * @returns 新しいタイムスタンプ(setMinutes()の戻り値)
 */
export function addMinutes(date: Date, add: number): number {
  return date.setMinutes( date.getMinutes() + add );
}

/**
 * 'hh:mm'形式の文字列に変換。
 * @param date
 * @returns
 */
export function dateToString_hhmm(date: Date): string {
  const PAD = '0';
  return date.getHours().toString().padStart(2, PAD) + ':'
    + date.getMinutes().toString().padStart(2, PAD);
}

/**
 * 'YYYY/MM/DD hh:mm:ss'形式の文字列に変換。
 * @param date
 * @returns
 */
export function dateToString_YYYYMMDD_hhmmss(date: Date): string {
  return numberToString_YYYYMMDD_hhmmss(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds() );
}

/**
 * 'YYYY/MM/DD hh:mm:ss'形式の文字列に変換。
 * @param year
 * @param monthNo 月番号(0が1月)
 * @param day 日（1が1日）
 * @param hour
 * @param minute
 * @param second
 * @returns
 */
export function numberToString_YYYYMMDD_hhmmss(year: number, monthNo: number= 0, day: number= 1, hour: number= 0, minute: number= 0, second: number= 0 ): string {
  const PAD = '0';
  return year.toString().padStart(2, PAD) + '/'
    + (monthNo + 1).toString().padStart(2, PAD) + '/'
    + day.toString().padStart(2, PAD) + ' '
    + hour.toString().padStart(2, PAD) + ':'
    + minute.toString().padStart(2, PAD) + ':'
    + second.toString().padStart(2, PAD);
}
